import {ID, Response} from '../../../../../../_metronic/helpers'
export type PlanFeatures = {
  id?: ID
  primaryId?: number
  name?: string
 
 
  message?: string
  status?: string
  createdBy?: number
}

export type PlanFeaturesQueryResponse = Response<Array<PlanFeatures>>

export const initialPlanFeatures: PlanFeatures = {
  name: '',
  
  createdBy: 0,
}
export type UpdatePlanFeatures = {
  id?: ID
  primaryId?: number
  name?: string
 
  status?: string
  updatedBy?: number
}

export type UpdatePlanFeaturesQueryResponse = Response<Array<UpdatePlanFeatures>>

export const initialUpdatePlanFeatures: UpdatePlanFeatures = {
  name: '',
  
}
